import {Injectable} from '@angular/core';
import {EcommerceDashboardPeriod, WebRefundService} from 'web-angular-client';
import {Helper} from '../../util/helper';
import {ISearchableService} from './ISearchableService';
import {browserTimezone} from './ecommerce-account-search.service';

/**
 * Drives the refund transactions list search. Mirrors {@link EcommerceAccountSearchService}: amount filters are
 * converted from major (rand) to minor (cents) before being sent, and an optional period preset is forwarded so the
 * backend resolves the date-created window server-side. Implements {@link ISearchableService} so the shared
 * {@code SearchService} can drive it.
 */
@Injectable({
    providedIn: 'root'
})
export class RefundSearchService implements ISearchableService
{
    currentPeriod: EcommerceDashboardPeriod | null = null;

    constructor(private readonly webRefundService: WebRefundService)
    {
    }

    search(pageNumber: number, pageSize: number, sortField: string, sortOrder: string, searchCriteria: any)
    {
        const criteria = {
            ...searchCriteria,
            amountUpper: Helper.convertToMinorDenomination(searchCriteria?.amountUpper) ?? undefined,
            amountLower: Helper.convertToMinorDenomination(searchCriteria?.amountLower) ?? undefined
        };

        const direction: 'ASC' | 'DESC' = sortOrder === 'ASC' ? 'ASC' : 'DESC';
        return this.webRefundService.searchRefunds(
            pageNumber,
            pageSize,
            sortField,
            direction,
            this.currentPeriod ?? undefined,
            browserTimezone(),
            criteria);
    }
}
